<template>
  <v-card flat class="pa-4" style="flex-grow: 1">
    <ShopVue :profileView="true" />
  </v-card>
</template>

<script>
import { Capacitor } from '@capacitor/core';
import ShopVue from '../public/Shop.vue';

export default {
  name: "landingPageShopComponent",

  data() {
    return {
    };
  },

  components: {
    ShopVue
  },
  beforeMount(){
    if(Capacitor.isNativePlatform()){
      window.open(this.$localURL + "/login", "_system");
      this.$router.back();
    }
  }

};
</script>

<style>
</style>
